import React from 'react';
import PropTypes from 'prop-types';

import CheckboxGroup from '../../../../components/molecules/CheckboxGroup';
import FormLabel from '../../../../components/atoms/FormLabel';

const ContactPreference = (props) => {
  const {
    disabled,
    contactOptions,
    onChange,
  } = props;

  return (
    <div>
      <FormLabel label="Contact Preference" />
      <br />
      <CheckboxGroup
        inline
        name="contactPreference"
        type="radio"
        onChange={onChange}
        disabled={disabled}
        checkboxList={contactOptions}
      />
    </div>
  );
};

ContactPreference.propTypes = {
  disabled: PropTypes.bool,
  contactOptions: PropTypes.arrayOf(
    PropTypes.object,
  ).isRequired,
  onChange: PropTypes.func,
};

ContactPreference.defaultProps = {
  disabled: false,
  onChange: null,
};

export default ContactPreference;
